/**
 * 为了能够兼容 Android 4.x 系列，这里不能使用 fetch 作为请求的工具
 * 这里采用原生的 XMLHttpRequest 进行 ajax 请求，但是为了避免给老
 * 代码带来巨大冲击，这里需要封装一下接口，使得其和原来的版本相同
 */

export default function request(url, options = {}) {
  const { headers = {} } = options
  options.headers = {
    'Content-Type': 'text/plain; charset=utf-8',
    ...headers
  }
  if (
    options.method === 'POST' ||
    options.method === 'PUT' ||
    options.method === 'DELETE'
  ) {
    options.body = JSON.stringify(options.body) || null
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(options.method || 'GET', url, true)
    xhr.withCredentials = options.credential || true
    Object.keys(options.headers).forEach(key => {
      xhr.setRequestHeader(key, options.headers[key])
    })
    xhr.timeout = options.timeout || 10000
    xhr.onload = function() {
      if ((this.status >= 200 && this.status < 300) || this.status === 304) {
        const data = JSON.parse(this.responseText)
        resolve(data)
      } else {
        reject(new Error('服务端错误'))
      }
    }
    xhr.onerror = function() {
      reject(new Error('网络错误'))
    }

    xhr.ontimeout = function() {
      reject(new Error('网络超时'))
    }
    xhr.send(options.body || null)
  })
}
